import Api from "@/services/Api";
export default {
  addLead(params) {
    return Api().post("/api/crm/customer", params)
  },
  getCampaigns() {
    return Api().get("/api/crm/campaign")
  }
}